.container {
  /* panel radius = control radius + panel padding / 2 */
  border-radius: calc(6px + 18px / 2);
  /* toolbar is about 50px */
  max-height: calc(100vh - 70px);
  overflow: hidden;

  /* For scroll area
  https://stackoverflow.com/questions/8468066/child-inside-parent-with-min-height-100-not-inheriting-height
  */
  display: flex;
  flex-direction: column;
}

.content {
  padding: 18px;
}
